export default "__VITE_ASSET__DfBcR21p__"